import { ActionComplaintTypeEnum } from 'ws-voice-infinity-global-module/lib/enums';
import { IPublicStatusComplaintItem } from 'ws-voice-infinity-global-module/lib/interfaces';
import { TypeService } from 'ws-voice-infinity-global-module/lib/services';

export enum PublicStatusComplaintEnum {
    DRAFT = 'DRAFT',
    MODERATION = 'MODERATION',
    IN_WORK = 'IN_WORK',
    REJECTED = 'REJECTED',
    HAS_MEETING_DATE = 'HAS_MEETING_DATE',
    CONFIRMED = 'CONFIRMED',
    CANCELLED_BY_EXECUTOR = 'CANCELLED_BY_EXECUTOR',
    CANCELLED_BY_AUTHOR = 'CANCELLED_BY_AUTHOR',
    HELD = 'HELD',
    COMPLETED = 'COMPLETED',
    FINISHED = 'FINISHED',
}

interface IPublicStatusComplaint {
    [value: string]: IPublicStatusComplaintItem;

    DRAFT: IPublicStatusComplaintItem;
    MODERATION: IPublicStatusComplaintItem;
    IN_WORK: IPublicStatusComplaintItem;
    REJECTED: IPublicStatusComplaintItem;
    HAS_MEETING_DATE: IPublicStatusComplaintItem;
    CONFIRMED: IPublicStatusComplaintItem;
    CANCELLED_BY_EXECUTOR: IPublicStatusComplaintItem;
    CANCELLED_BY_AUTHOR: IPublicStatusComplaintItem;
    HELD: IPublicStatusComplaintItem;
    COMPLETED: IPublicStatusComplaintItem;
    FINISHED: IPublicStatusComplaintItem;
}

/**
 * Публичный статус обращения
 */
const PUBLIC_STATUS_COMPLAINT: IPublicStatusComplaint = {
    DRAFT: {
        name: 'Черновик',
        value: 'DRAFT',
        type: 'default',
        actions: [
            {
                name: 'Редактировать',
                icon: 'assets/images/svg/action_complaint_edit.svg',
                actionType: ActionComplaintTypeEnum.EDIT,
            },
            {
                icon: 'assets/images/svg/action_complaint_delete.svg',
                actionType: ActionComplaintTypeEnum.DELETE,
            },
        ],
    },
    MODERATION: {
        name: 'На регистрации',
        value: 'MODERATION',
        type: 'process',
        actions: [],
    },
    IN_WORK: {
        name: 'В работе',
        value: 'IN_WORK',
        type: 'process',
        actions: [],
    },
    REJECTED: {
        name: 'Отклонено',
        value: 'REJECTED',
        type: 'error',
        actions: [],
    },
    HAS_MEETING_DATE: {
        name: 'Назначена дата',
        value: 'HAS_MEETING_DATE',
        type: 'process',
        actions: [],
    },
    CONFIRMED: {
        name: 'Подтвержден',
        value: 'CONFIRMED',
        type: 'process',
        actions: [],
    },
    CANCELLED_BY_EXECUTOR: {
        name: 'Отменен исполнителем',
        value: 'CANCELLED_BY_EXECUTOR',
        type: 'error',
        actions: [],
    },
    CANCELLED_BY_AUTHOR: {
        name: 'Отменен заявителем',
        value: 'CANCELLED_BY_AUTHOR',
        type: 'error',
        actions: [],
    },
    HELD: {
        name: 'Проведен',
        value: 'HELD',
        type: 'process',
        actions: [],
    },
    COMPLETED: {
        name: 'Завершен',
        value: 'COMPLETED',
        type: 'success',
        actions: [],
    },
    FINISHED: {
        name: 'Завершен. Требуется ответ',
        value: 'FINISHED',
        type: 'success',
        actions: [],
    },
};

export default PUBLIC_STATUS_COMPLAINT;

export const PublicStatusComplaintType = TypeService.createEnum<PublicStatusComplaintEnum>(PublicStatusComplaintEnum, 'PublicStatusComplaintEnum');
